import { Api } from 'src/core/decorators/dto/api.decorator';
import { DtoHasApi } from '../shared/dto-has-api.model';


@Api('api/app/configuration-settings/setting')
export class ConfigurationSettingsDto extends DtoHasApi  {
    settingName:string;
    settingValue:any;
}